import {
  GraphQLNonNull,
  GraphQLInputObjectType,
  GraphQLString,
  GraphQLList,
  GraphQLID
} from 'graphql'

export interface CustomMetadataFilter {
  readonly fieldID: string
  readonly values: string[]
}

export const customMetadataFilter = new GraphQLInputObjectType({
  name: 'CustomMetadataFilter',
  description: 'Filter by a custom metadata field',
  fields: () => ({
    fieldID: {
      description: 'ID of the custom metadata field',
      type: new GraphQLNonNull(GraphQLID)
    },
    values: {
      description: 'Custom metadata field value IDs to filter on',
      type: new GraphQLNonNull(new GraphQLList(new GraphQLNonNull(GraphQLID)))
    }
  })
})

export interface ApplicationFilterArg {
  readonly scores?: string[]
  readonly tags?: string[]
  readonly technologies?: string[]
  readonly languages?: string[]
  readonly servers?: string[]
  readonly compliance?: string[]
  readonly openVulnSeverities?: string[]
  readonly filterText?: string
  readonly quickFilter?: string
  readonly customMetadata?: CustomMetadataFilter[]
  readonly environment?: string[]
  readonly appImportances?: string[]
}

const filterList = new GraphQLList(GraphQLString)

export const ApplicationFilterArgType = new GraphQLInputObjectType({
  name: 'ApplicationFilterArg',
  description:
    'A collection of criteria categories and values to filter the applications by. Each criteria category consists of a list of strings. Categories of criteria are applied with an AND relationship. Within each category, the individual criteria values are applied with an OR relationaship',
  fields: () => ({
    scores: {
      description: 'Filters applications by score',
      type: filterList
    },
    tags: {
      description: 'Filters applications by tags',
      type: filterList
    },
    technologies: {
      description: 'Filters applications by technology name',
      type: filterList
    },
    languages: {
      description: 'Filters applications by language',
      type: filterList
    },
    servers: {
      description: 'Filters applications by server ID',
      type: filterList
    },
    compliance: {
      description:
        'Filters application by those that violate certain compliance policies',
      type: filterList
    },
    openVulnSeverities: {
      description: 'Filters applications by open vulnerability severities',
      type: filterList
    },
    filterText: {
      description: 'Filter applications that match the specified text string',
      type: GraphQLString
    },
    quickFilter: {
      description: 'An optional predefined filter',
      type: GraphQLString
    },
    customMetadata: {
      description: 'Filter by custom metadata fields',
      type: new GraphQLList(customMetadataFilter)
    },
    environment: {
      description: 'Filters applications by server environment',
      type: new GraphQLList(GraphQLString)
    },
    appImportances: {
      description: 'Filters applications by application importance',
      type: new GraphQLList(GraphQLString)
    }
  })
})
